module.exports = __webpack_public_path__ + "static/media/lock-border.7f77df7d.svg";